import {Artist} from '@app/web-player/artists/artist';
import {SmallArtistImage} from '@app/web-player/artists/artist-image/small-artist-image';
import {PlayableGridItem, DefaultGridElement} from '@app/web-player/playable-item/playable-grid-item';
import {ArtistContextDialog} from '@app/web-player/artists/artist-context-dialog';
import {ArtistLink, getArtistLink} from '@app/web-player/artists/artist-link';
import {LikeIconButton} from '@app/web-player/library/like-icon-button';
import { ArtistPage } from './artist-page/artist-page';
import {LiveEventArtist} from '@app/admin/live-events/interfaces/live-event-artist';
import { Channel } from '@common/channels/channel';
import { ChannelContentModel } from '@app/admin/channels/channel-content-config';
import { useArtist } from './requests/use-artist';
import {normalizeStorageUrl} from '@ui/utils/urls/normalize-storage-url';

interface ArtistGridItemProps {
  artist: Artist;
  radius?: string;
  contentFormat?: string;
}
export function ArtistGridItem({
  artist,
  radius = 'rounded-full',
  contentFormat
}: ArtistGridItemProps) {
  return (
    <PlayableGridItem
      item={<ArtistPage artist={artist} />}
      image={<SmallArtistImage artist={artist} />}
      title={<ArtistLink artist={artist} />}
      model={artist}
      link={getArtistLink(artist)}
      likeButton={<LikeIconButton likeable={artist} />}
      contextDialog={<ArtistContextDialog artist={artist} />}
      radius={radius}
      contentFormat={contentFormat}
    />
  );
}

interface LiveEventArtistGridItemProps {
  artist: LiveEventArtist;
}

export function LiveEventArtistGridItem({artist}: LiveEventArtistGridItemProps) {
  const {data} = useArtist({
    artistId: artist.artist_id,
    loader: 'artist',
  });

  const linkedArtist = data?.artist;

  if (linkedArtist) {
    return (
      <ArtistGridItem artist={linkedArtist} radius="rounded-full" contentFormat="square"/>
    );
  }

  return (
    <DefaultGridElement
      image={
        artist.image ? (
          <img
            src={normalizeStorageUrl(artist.image)}
            alt={artist.name}
            className="rounded-full object-cover"
          />
        ) : (
          <div className="rounded-full bg-gray-200 w-full h-full" />
        )
      }
      title={<div className="truncate">{artist.name}</div>}
      subtitle={artist.origin ? <div>{artist.origin}</div> : undefined}
      radius="rounded-full"
    />
  );
}

